var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-stage',[(_vm.data)?_c('ui-admin-table',{attrs:{"attributes":_vm.attributes,"data":_vm.data,"module-url":_vm.moduleUrl,"pagination-method":"front-end","link-create":_vm.linkCreate}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }